import { Check, Sparkles } from "lucide-react";
import { PACKAGES } from "@/lib/prices";
import { Reveal, Eyebrow } from "../Reveal";

const Card = ({ p, onBook, delay }) => (
  <Reveal delay={delay} className={`flex h-full flex-col rounded-[32px] p-7 sm:p-10 ${p.dark ? "bg-espresso text-cream" : "border border-gold/35 bg-paper text-ink"}`}>
    <div data-testid={`package-${p.id}`} className="flex h-full flex-col">
      <p className={`text-[11px] font-semibold uppercase tracking-[0.26em] ${p.dark ? "text-gold-light" : "text-gold-deep"}`}>{p.dark ? "Exklusiv" : "Einstieg"}</p>
      <h3 className="mt-3 font-serif text-3xl sm:text-4xl">{p.title}</h3>
      <p className="mt-4 font-serif">
        <span className={`text-5xl sm:text-6xl ${p.dark ? "text-gold-light" : "text-gold-deep"}`}>{p.price}</span>
        <span className={`ml-2 text-lg italic ${p.dark ? "text-cream/80" : "text-ink-soft"}`}>/ Monat</span>
      </p>
      <p className={`mt-4 font-serif text-xl italic ${p.dark ? "text-cream" : "text-ink"}`}>{p.tagline}</p>
      <p className={`mt-6 text-[11px] font-semibold uppercase tracking-[0.22em] ${p.dark ? "text-gold-light" : "text-gold-deep"}`}>Inklusive</p>
      <ul className="mt-3 space-y-2.5">
        {p.includes.map((i) => (
          <li key={i} className={`flex items-start gap-3 text-[15px] ${p.dark ? "text-cream/90" : "text-ink-soft"}`}>
            <Check className={`mt-0.5 h-4 w-4 shrink-0 ${p.dark ? "text-gold-light" : "text-gold-deep"}`} strokeWidth={2} /> {i}
          </li>
        ))}
      </ul>
      <p className={`mt-6 text-sm leading-relaxed ${p.dark ? "text-cream/80" : "text-ink-soft"}`}>{p.note}</p>
      <button
        onClick={() => onBook(p.title)}
        data-testid={`package-book-${p.id}`}
        className={`mt-auto self-start rounded-full px-7 py-3.5 text-[12px] font-semibold uppercase tracking-[0.2em] ${p.dark ? "btn-gold" : "bg-espresso text-cream"}`}
        style={{ marginTop: "2rem" }}
      >
        Paket anfragen
      </button>
    </div>
  </Reveal>
);

export const Packages = ({ onBook }) => (
  <section id="pakete" data-testid="price-category-pakete" className="scroll-mt-32 border-t border-gold/25 py-16 lg:py-24">
    <Reveal>
      <Eyebrow index="08">Monthly Packages</Eyebrow>
      <h2 className="mt-5 font-serif text-4xl leading-[1.05] text-ink sm:text-5xl">
        Deine Beauty-Routine <span className="italic text-gold-deep">jeden Monat.</span>
      </h2>
      <p className="mt-4 flex items-start gap-2 text-sm text-ink" data-testid="price-consult-pakete">
        <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" strokeWidth={1.6} /> Individuelle Beratung inklusive – deine Treatments stimmen wir gemeinsam auf dich ab.
      </p>
    </Reveal>
    <div className="mt-10 grid gap-6 lg:grid-cols-2">
      {PACKAGES.map((p, i) => <Card key={p.id} p={p} onBook={onBook} delay={i * 0.1} />)}
    </div>
  </section>
);
